import { v4 as uuidv4 } from "uuid";
import { createContext, useContext, useState, useEffect } from "react";
import { UserDataProvider } from "./UserDataProvider";

const UserContext = createContext({
  auth: { username: "", guest: "", loggedIn: false },
  login: async () => {
    throw new Error("Not configured");
  },
  logout: async () => {
    throw new Error("Not configured");
  },
});

export const UserProvider = ({ children }) => {
  
  const getGuestUser = () => {
    let guest = localStorage.getItem("guest");
    if (!guest) {
      guest = uuidv4();
      localStorage.setItem("guest", guest);
    }
    return guest;
  };

  const [auth, setAuth] = useState({ username: "", guest: getGuestUser(), loggedIn: false });

  useEffect(() => {
    async function fetchUser() {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/user`, {
          method: 'POST',
          credentials: 'include',
          headers: { "Content-Type": "application/json" },
        })
        if (!res.ok) {
          await logout();
          return;
        }
        const json = await res.json();
        setAuth({ username: json.username, guest: getGuestUser(), loggedIn: true });
      } catch (error) {
        console.log("Request failed", error);
        await logout();
      }
    }
    fetchUser();
    console.log("fetching user");
  }, []);
 
  const login = () => {
    window.location.href = `${process.env.REACT_APP_API_URL}/auth/login?return_to=${window.location.href}`;
  };

  const logout = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/auth/logout`, {
        method: 'POST',
        credentials: 'include',
        headers: { "Content-Type": "application/json" },
      });
      if (!res.ok) {
        console.log("Logout failed");
      }
    } catch (error) {
      console.log("Request failed", error);
    }
    // Clear the auth state regardless of the logout request result
    setAuth({ username: "", guest: getGuestUser(), loggedIn: false });
  };

  const fetchAuth = async (url, options = {}) => {
    try {
      if (auth.loggedIn) {
        console.log("fetching with auth");
        const res = await fetch(url, {
          method: "POST",
          credentials: 'include',
          headers: { "Content-Type": "application/json" },
          ...options,
          body: JSON.stringify(options.body),
        });

        if (res.status !== 401) {
          console.log("return fetching with auth");
          return res;
        } else {
          console.log("fail fetching with auth");
          await logout();
          // continue with guest fetch
        }
      }

      console.log("fetching with guest");
      return await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json", "x-guest-uuid": auth.guest },
        ...options,
        body: JSON.stringify(options.body),
      });
    } catch (error) {
      console.log("Request failed", error);
    }
  }

  return (
    <UserContext.Provider value={{ auth, login, logout, fetchAuth }}>
      <UserDataProvider>{children}</UserDataProvider>
    </UserContext.Provider>
  );
};

export const useUser = () => useContext(UserContext);
